import { useEffect, useRef, useState } from 'react'
import { LogOut, Settings } from 'lucide-react'
import { platformEnv } from '@/platform/config/env'
import { useFeatureSelector } from '@/platform/state/hooks'
import { clearSessionTokens, redirectToLogin } from './sessionTokens'
import type { SessionUser } from './sessionSlice'
import './userAvatarMenu.css'

export function UserAvatarMenu() {
  const [open, setOpen] = useState(false)
  const [imageFailed, setImageFailed] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const user = useFeatureSelector((state) => (state as { session: { user: SessionUser | null } }).session.user)

  useEffect(() => {
    const close = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [])

  if (!user) return null
  const name = user.display_name || user.email
  const initial = name.charAt(0).toUpperCase()
  const logout = () => {
    setOpen(false)
    clearSessionTokens()
    redirectToLogin()
  }

  const hasAvatar = Boolean(user.avatar && !imageFailed)

  return <div className="avatar-menu" ref={menuRef}>
    <button type="button" className="avatar-button" onClick={() => setOpen((value) => !value)} aria-label="Tài khoản" aria-expanded={open}>
      {hasAvatar ? <span className="avatar-image"><img src={user.avatar!} alt="" onError={() => setImageFailed(true)} /></span> : <span className="avatar-initial">{initial}</span>}
    </button>
    {open && <div className="avatar-popover">
      <div className="avatar-summary"><strong>{name}</strong><span>{user.email}</span></div>
      <a href={platformEnv.ssoFrontendUrl} className="avatar-action"><Settings size={16} />Quản lý tài khoản</a>
      <button type="button" className="avatar-action danger" onClick={logout}><LogOut size={16} />Đăng xuất</button>
    </div>}
  </div>
}
